import '../../../../../assets/scss/style.scss';

import { useEffect, useMemo, useState, useRef } from 'react';
import { SidebarContainer, SidebarDoubleArrowToggleButton } from './styled';
import { useSidebar, useSidebarNavItemCollapse } from './context';

import Box from '@mui/material/Box';
import { DoubleArrow } from '@mui/icons-material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SidebarList from '@/common/presentation/components/layout/Sidebar/SidebarList';
import SidebarNavUser from './SidebarList/SidebarNavUser';
import StyledDrawer from '../StyledDrawer';
import { useLocation } from 'react-router-dom';
import { useUserPreferences } from '@/common/application/hooks/userPreferencesHook';

const Sidebar = () => {
  const { getUserName } = useUserPreferences(localStorage.getItem('userName') as string);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const flagRef = useRef(true);

  const [drawerWidth, setDrawerWidth] = useState(window.innerWidth > 1440 ? 260 : 240);
  const [transitionButtonLeft, setTransitionButtonLeft] = useState(window.innerWidth > 1440 ? 245 : 225);
  const userName = getUserName();

  const { isSideBarOpen, setIsSideBarOpen } = useSidebar();

  const { pathname } = useLocation();
  const { setCurrentMenuActive } = useSidebarNavItemCollapse();

  const openedTransition = {
    left: transitionButtonLeft,
    transition: 'left 225ms cubic-bezier(0.4, 0, 0.6, 1)',
  };

  const closedTransition = {
    left: 65,
    transition: 'left 200ms cubic-bezier(0.4, 0, 0.6, 1)',
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenWidth(width);
      setDrawerWidth(width > 1440 ? 260 : 240);
      setTransitionButtonLeft(width > 1440 ? 245 : 225);

      if (width <= 991 && flagRef.current === true) {
        flagRef.current = false;
        setIsSideBarOpen(false);
      }

      if (width > 991) {
        if (flagRef.current === false) {
          setIsSideBarOpen(true);
        }
        flagRef.current = true;
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const drawerContent = useMemo(
    () => (
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flexGrow: 1, minHeight: 0 }}>
          <PerfectScrollbar className="disable_ps__rail-x" style={{ height: '100%', paddingTop: '1rem', paddingBottom: '1rem' }}>
            <SidebarList />
          </PerfectScrollbar>
        </Box>
        <Box sx={{ mt: 'auto', display: 'flex' }}>
          <SidebarNavUser name={userName} />
        </Box>
      </Box>
    ),
    [userName],
  );

  if (screenWidth < 576) {
    return null;
  }

  return (
    <SidebarContainer>
      <SidebarDoubleArrowToggleButton
        onClick={() => {
          setIsSideBarOpen(!isSideBarOpen);
          setCurrentMenuActive(pathname.replace('/', ''));
        }}
        sx={isSideBarOpen ? openedTransition : closedTransition}
      >
        <DoubleArrow style={{ color: 'white', transform: isSideBarOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
      </SidebarDoubleArrowToggleButton>
      <Box>
        <StyledDrawer variant="permanent" open={isSideBarOpen} drawerWidth={drawerWidth}>
          {drawerContent}
        </StyledDrawer>
      </Box>
    </SidebarContainer>
  );
};

export default Sidebar;
